import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from '../common/FadeIn';

const BlogGridSection = ({
  displayedPosts,
  filteredPostsLength,
  initialCount,
  hasMore,
  onToggleVisible,
  sortBy = 'recent',
  onSortChange,
}) => {
  return (
    <>
      <FadeIn className="mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <h2 className="font-PromenadeItalic text-[28px] sm:text-[34px] font-normal text-[#1C1917]">
          {sortBy === 'recent'
            ? 'Recent posts'
            : sortBy === 'newest'
              ? 'All posts (Newest first)'
              : sortBy === 'oldest'
                ? 'All posts (Oldest first)'
                : 'Posts (A-Z)'}
        </h2>

        {onSortChange && (
          <div className="flex items-center gap-2">
            <span className="font-PromenadeItalic text-[13px] md:text-[15px] lowercase tracking-normal text-[#1C1917] capitalize mr-1">
              Sort By :
            </span>
            <select
              value={sortBy}
              onChange={(e) => onSortChange(e.target.value)}
              className="bg-[#f9f6f3] text-[11px] font-interDisplayMedium text-[#1C1917] py-1.5 px-3 border border-[#E8E2D8] rounded-none focus:outline-none cursor-pointer hover:border-[#1C1917] transition-colors"
            >
              <option value="recent">Recent Posts (Newest)</option>
              <option value="newest">All Posts (Newest First)</option>
              <option value="oldest">All Posts (Oldest First)</option>
              <option value="title">Alphabetical (A - Z)</option>
            </select>
          </div>
        )}
      </FadeIn>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 lg:gap-12">
        {displayedPosts.map((post) => (
          <FadeIn key={post.id} className="group flex flex-col">
            <Link to={`/blog/${post.slug}`} className="block overflow-hidden mb-4 bg-[#EFECE6] aspect-[4/3] sm:aspect-[1/1]">
              <img
                src={post.featuredImage}
                alt={post.title}
                className="w-full h-full object-cover object-center"
                loading="lazy"
                decoding="async"
                width="400"
                height="400"
              />
            </Link>

            <div className="flex flex-col">
              <span className="font-interDisplayMedium text-[9px] md:text-[10px] uppercase tracking-[0.2em] font-bold text-[#8B8477] mb-2">
                {post.category}
              </span>

              <Link to={`/blog/${post.slug}`} className="group-hover:text-[#8C8275] transition-colors">
                <h3 className="font-saolDisplayItalic text-[20px] sm:text-[22px] md:text-[24px] font-normal leading-[1.25] text-[#1C1917]">
                  {post.title}
                </h3>
              </Link>
            </div>
          </FadeIn>
        ))}
      </div>

      {filteredPostsLength > initialCount && (
        <FadeIn className="w-full mt-12 sm:mt-16 flex justify-center">
          <button
            onClick={onToggleVisible}
            className="px-8 py-3 bg-[#0D0C0B] text-white font-interDisplayMedium text-[9px] lg:text-[11px] uppercase tracking-[0.15em] font-semibold rounded-sm shadow-sm cursor-pointer hover:bg-[#ccc3ad] hover:text-black duration-[0.5s] transition-colors"
          >
            {hasMore ? "SHOW MORE POSTS" : "SHOW LESS POSTS"}
          </button>
        </FadeIn>
      )}

      {filteredPostsLength === 0 && (
        <div className="text-center py-16">
          <p className="font-interDisplayMedium text-[#666666]">
            No blogs found.
          </p>
        </div>
      )}
    </>
  );
};

export default BlogGridSection;
